import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "autocompleteSection",
    "newFields",
    "submitButton",
    "suggestions",
    "businessNameInput",
    "selectedBusinessId"
  ]

  connect() {
    this.clearSuggestions()
  }

  async fetchSuggestions(event) {
    const query = event.target.value.trim()
    if (query.length < 2) return this.clearSuggestions()

    const response = await fetch(`/admin/businesses/autocomplete?query=${encodeURIComponent(query)}`)
    const businesses = await response.json()

    this.suggestionsTarget.innerHTML = ""
    businesses.forEach(biz => {
      const li = document.createElement("li")
      li.className = "cursor-pointer px-4 py-2 hover:bg-yellow-700 hover:text-white"
      li.textContent = biz.name
      li.onclick = () => {
        this.businessNameInputTarget.value = biz.name
        this.selectedBusinessIdTarget.value = biz.id
        this.clearSuggestions()
      }
      this.suggestionsTarget.appendChild(li)
    })

    this.suggestionsTarget.classList.remove("hidden")
  }

  showForm(event) {
    event.preventDefault()

    this.autocompleteSectionTarget.classList.add("hidden")
    this.newFieldsTarget.classList.remove("hidden")
    this.submitButtonTarget.value = "Create Business"
  }

  clearSuggestions() {
    this.suggestionsTarget.innerHTML = ""
    this.suggestionsTarget.classList.add("hidden")
  }
}
